/**
 * API для аутентификации
 */

import { apiClient } from './client';
import {
  saveToken, removeToken,
} from './tokenStorage';
import type {
  RegisterRequest, LoginRequest, AuthResponse, MeResponse,
} from '@/types/api';

/**
 * Регистрация пользователя
 */
export const register = async (data: RegisterRequest): Promise<AuthResponse> => {
  const response = await apiClient.post<AuthResponse>('/auth/register', data, {
    skipAuth: true, // Регистрация не требует токена
  });
  if (response.success && response.token) {
    saveToken(response.token);
  }
  return response;
};

/**
 * Вход пользователя
 */
export const login = async (data: LoginRequest): Promise<AuthResponse> => {
  const response = await apiClient.post<AuthResponse>('/auth/login', data, {
    skipAuth: true, // Вход не требует токена
  });
  if (response.success && response.token) {
    saveToken(response.token);
  }
  return response;
};

/**
 * Получение данных текущего пользователя
 */
export const getMe = async (): Promise<MeResponse> => apiClient.get<MeResponse>('/auth/me');

/**
 * Выход пользователя
 */
export const logout = (): void => {
  removeToken();
};

